import Swiper from 'swiper';

export default () => {
  const el = document.querySelector('[data-banner-slider]');
  
  if(el) {
    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");
  
    const options = {
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      navigation: {
        nextEl,
        prevEl,
      },
    };

    new Swiper(el, options);
  }
};